import { Card, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTable, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, Row } from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import TableHead from "../common/TableHead";
import { useGetViewedProducts } from "../../../customHooks/useGetViewedProducts";
import ProductInfoModal from "./_components/productInfoModal";
import { useState } from "react";

const MostViwedProductPage = () => {
  const { list, loading, refetch, } = useGetViewedProducts();
  const [productInfo, setProductInfo] = useState({});
  const [openModal, setOpenModal] = useState(false);
  console.log("list", list)
  return (
    <>
      <Head title="Most Viewed Products" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>
                Most Viewed Products
              </BlockTitle>
              <ul className="list list-sm" id="list-note">
                <li>This page shows your most viewed items in the past 90 days along with number of times they have been added to cart and purchased</li>
                <li>Click on the designer code to get the current available sizes and shipping timelines</li>
                <li>Click on product title to view images and get website link of the item</li>
              </ul>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Card className="card-stretch">
            {/* <Row className="gy-3">
              <Col lg={10}>
                <TableHead
                  searchHandler={() => { }}
                  searchFieldData={{}}
                  seachFeildType={{}}
                  reloadHandler={() => {
                    // handleGetData();
                  }}
                  setSearchText={() => { }}
                  setSelectedItems={() => { }}
                  pageName="purchase-order-listing"
                ></TableHead>
              </Col>
            </Row> */}
            <div className="card-inner-group">
              <DataTable className="card-stretch">
                <DataTableBody compact>
                  <DataTableHead>
                    {/* <DataTableRow size="md">
                      <span className="lead-text table-head">Product Id</span>
                    </DataTableRow> */}
                    <DataTableRow size="sm">
                      <span className="lead-text table-head">Designer Code</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span className="lead-text table-head">Category</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span className="lead-text table-head">Product Title</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span className="lead-text table-head">Views</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span className="lead-text table-head">Added To Cart</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span className="lead-text table-head">Total Purchase</span>
                    </DataTableRow>
                  </DataTableHead>
                  {list?.list?.map((pObj) => (
                    <DataTableItem key={pObj.product_id}>
                      {/* <DataTableRow size="md">
                        <Button onClick={() => {
                          setProductInfo({ id: pObj.product_id, productName: pObj.producttitle });
                          setOpenModal(true);
                        }
                        }>
                          <span>{pObj.product_id}</span>
                        </Button>
                      </DataTableRow> */}
                      <DataTableRow size="sm">
                        <Button color={""} onClick={() => {
                          setProductInfo({ id: pObj.product_id, productName: pObj.producttitle });
                          setOpenModal(true);
                        }
                        }>
                          <span>{pObj.designerCode}</span>
                        </Button>
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <span>{pObj.category} / {pObj.subcat}</span>
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <a href={pObj.url} target="_blank">{`${pObj.producttitle.substring(0, 20)}...`}</a>
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <span>{pObj.views}</span>
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <span>{pObj.added_to_cart}</span>
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <span>{pObj.purchase || "-"}</span>
                      </DataTableRow>
                    </DataTableItem>
                  ))}
                </DataTableBody>
              </DataTable>
            </div>
          </Card>
        </Block>
      </Content>
      {openModal && <ProductInfoModal isOpen={openModal} close={() => setOpenModal(false)} {...productInfo} />}
    </>
  )
}

export default MostViwedProductPage;